import api from './api';

class PerformanceReviewService {
  // Get all performance reviews with pagination and filtering
  static async getPerformanceReviews(params = {}) {
    try {
      const response = await api.get('/performance-reviews', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching performance reviews:', error);
      throw this.handleError(error);
    }
  }

  // Get performance review by ID
  static async getPerformanceReview(id) {
    try {
      const response = await api.get(`/performance-reviews/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching performance review:', error);
      const errorObj = this.handleError(error);
      // Preserve the error object so the component can access the message
      errorObj.response = error.response;
      throw errorObj;
    }
  }

  // Create new performance review
  static async createPerformanceReview(reviewData) {
    try {
      const response = await api.post('/performance-reviews', reviewData);
      return response.data;
    } catch (error) {
      console.error('Error creating performance review:', error);
      throw this.handleError(error);
    }
  }

  // Update performance review
  static async updatePerformanceReview(id, reviewData) {
    try {
      const response = await api.put(`/performance-reviews/${id}`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Error updating performance review:', error);
      throw this.handleError(error);
    }
  }

  // Delete performance review
  static async deletePerformanceReview(id) {
    try {
      const response = await api.delete(`/performance-reviews/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting performance review:', error);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        message: error.response.data?.message || 'An error occurred',
        status: error.response.status,
        data: error.response.data
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default PerformanceReviewService;

